/**
 * Для Input: ограничение вводимых значений натуральными числами (передавать в onInput)
 */

export const onlyNumbers = (e: any, options?: { withoutZero?: true }) => {
  const withoutZero = options?.withoutZero;
  const regex = withoutZero ? /[^1-9]|0/g : /\D/g;
  e.target.value = e.target.value.replace(regex, "");
};
